import React, { useContext, useEffect, useMemo } from 'react'
import textStyles from "../../../../../assets/styles/componentStyles/manychatStyles/instagramStepComponent.module.scss"
import styles from '../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import contactStyles from '../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss'
import inboxStyles from "../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss"
import globalStyles from "../../../../../assets/styles/global.module.scss";
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../context/flowBuilderContext';
import { WorkflowContext, WorkflowContextPayload } from '../../../../../context/workflowContext';
import { Autocomplete, Chip, Grid, TextField } from '@mui/material';
import GlobalTooltip from '../../../../utility/tooltip/globalTooltip';
import RefreshIcon from '@mui/icons-material/Refresh';
import { ACTION_TYPE_NAME } from '../../flowBuilderConstants';
import { useRuleBasedInboxStore } from '../../../../../store/ruleBasedInboxStore';
import { useShallow } from 'zustand/react/shallow';
import { threadTagsData } from '../../../../../models/axiosModel';
import { isCurrentViewVersionPublished } from '../../utilityFunctions';
import RenderCustomOption from '../../../../global/autocomplete/renderCustomOption';
import { filterAutocompleteOptionsWithException } from '../../../../../utils/constants'
import { getNewThreadTagObj } from '../../../../../pages/ruleBasedInbox/constants'
import { renderThreadTagChip } from '../../../../../pages/ruleBasedInbox/renderUtils'

const AssignAndRemoveTagComponent = (props: any) => {
    
    const { actionData, stepAction } = props;

    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const { onChangeCurrentActiveNodeConfig, nodes, onBlurOfFallBackOfBtnVar, currentActiveNodeConfig } = useContext(FlowBuilderContext) as FlowBuilderContextPayload
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload

    const { threadTagsData, getThreadTagApi, setSelectedThreadTag, setFlagUpdateThreadTagPopup } = useRuleBasedInboxStore(useShallow((state) => ({
        threadTagsData: state.threadTagsData,
        getThreadTagApi: state.getThreadTagApi,
        setSelectedThreadTag: state.setSelectedThreadTag,
        setFlagUpdateThreadTagPopup: state.setFlagUpdateThreadTagPopup
    })));

    const getThreadTagApiCall = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await getThreadTagApi();
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    useEffect(() => {
        if(!threadTagsData){
            getThreadTagApiCall(); // GET Thread Tag API Call.
        }
    }, []);

    const getOptionsOfTagList = () => {
        if(threadTagsData){
            return [...threadTagsData, getNewThreadTagObj];
        }
        return [];
    }

    const getValueOfTag = () => {
        if(threadTagsData){
            return threadTagsData?.find((tag) => (actionData?.ticket_tag_id)?.toString() == (tag?.ticket_tag_id)?.toString()) ?? null
        } 
        return null;
    }

    const onChangeOfTag = (value: threadTagsData | null) => {
        const updateTagObj = {
            ticket_tag_id: value ? value?.ticket_tag_id : null,
            ticket_tag_name: value ? value?.ticket_tag_name : "",
            ticket_tag_color: value ? value?.ticket_tag_color : null
        }

        const updateTypeObj = {
            updateType: "editExistingStepAction"
        }
        onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, updateTagObj, updateTypeObj); 

        if(value){
            onBlurOfFallBackOfBtnVar(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, updateTagObj, updateTypeObj);
        }
    }

    const checkDisableTagOption = (option: threadTagsData) => {
        const node = nodes?.find((node: any) => node?.id == stepAction?.chatbot_step_id);
        if(node){
            const action = node?.data?.find((action: any) => (action?.chatbot_step_action_id != stepAction?.chatbot_step_action_id && (action?.action_type?.action_type_name == ACTION_TYPE_NAME["ASSIGN_TAG"] || action?.action_type?.action_type_name == ACTION_TYPE_NAME["REMOVE_TAG"])));
            if(action){
                if(action?.action_data?.ticket_tag_id == option?.ticket_tag_id){
                    return true;
                }
            }
        }
        return false;
    }

    const renderThreadTagOption = (option: threadTagsData) => (
        renderThreadTagChip(option?.ticket_tag_name, option?.ticket_tag_color, { isOption: true })
    )

    const renderTagOption = (props: React.HTMLAttributes<HTMLLIElement>, option: threadTagsData): React.ReactNode => {
        const isCustomOption = option?.ticket_tag_id === "-1";

        const optionForRender = { ...option, contact_tag_id: isCustomOption ? -1 : option?.ticket_tag_id };

        return (
            <RenderCustomOption
                autocompleteRenderOptionProps={props}
                option={optionForRender}
                customOptionName="New Tag"
                optionName={option?.ticket_tag_name}
                optionLabelKey="ticket_tag_id"
                onClickOfCustomOption={() => {
                    setSelectedThreadTag(null);
                    setFlagUpdateThreadTagPopup(true);
                }}
                flagRenderCustomOption
                renderCustomOption={(option) => renderThreadTagOption(option)}
            />
        );
    };

    const getActionName = useMemo(() => {
        const actionTypeName = stepAction?.action_type?.action_type_name;
        if(actionTypeName === ACTION_TYPE_NAME["ASSIGN_TAG"]){
            return "Assign Tag";
        }
        return "Remove Tag";
    }, [stepAction?.action_type?.action_type_name])

    return (
        <>
            <Grid item mt={2} className={textStyles.templatesContainer}>
                <Grid container direction={"column"} gap={"8px"} flexWrap={"nowrap"}>
                    <Grid item className={`${styles.bodyFormHeadingStyle} ${globalStyles.primaryFontSize} ${globalStyles.primaryFontWeight}`}>
                        {getActionName}
                    </Grid>
                    <Grid item>
                        <Grid container className={globalStyles.displayFlex} gap={"5px"} flexWrap={"nowrap"}>
                            <Grid item xs={11.5}>
                                <Autocomplete
                                    className={`${inboxStyles.threadTagAutocomplete}`}
                                    options={getOptionsOfTagList()}
                                    value={getValueOfTag()}
                                    getOptionLabel={(option: threadTagsData) => option?.ticket_tag_name ?? ''}
                                    onChange={(e, value) => onChangeOfTag(value)}
                                    ListboxProps={{ className: contactStyles.singleContactListbox }}
                                    renderOption={renderTagOption}
                                    getOptionDisabled={(option) => checkDisableTagOption(option)}
                                    filterOptions={(options, state) => filterAutocompleteOptionsWithException(options, state, "ticket_tag_name", "ticket_tag_id")}
                                    disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                    clearIcon={null}
                                    renderInput={params => {
                                        const { InputProps, inputProps, ...restParams } = params;
                                        const { startAdornment, ...restInputProps } = InputProps;
                                        return (
                                            <TextField
                                                {...restParams}
                                                placeholder={getValueOfTag() ? '' : 'Select Tag'}
                                                inputProps={{
                                                    ...inputProps,
                                                    readOnly: !!getValueOfTag(),
                                                    style: {
                                                        caretColor: getValueOfTag() ? 'transparent' : undefined,
                                                    },
                                                    value: getValueOfTag() ? '' : inputProps.value,
                                                }}
                                                InputProps={{
                                                    ...restInputProps,
                                                    startAdornment: getValueOfTag() ? (
                                                        <div className={contactStyles.selectTagTextField}>
                                                            {renderThreadTagChip(getValueOfTag()?.ticket_tag_name ?? '', getValueOfTag()?.ticket_tag_color)}
                                                        </div>
                                                    ) : null
                                                }}
                                            />
                                        );
                                    }}
                                />
                            </Grid>
                            <Grid item xs={0.5}>
                                <GlobalTooltip
                                    title="Fetch latest tags"
                                    placement='top'
                                    arrow
                                >
                                    <RefreshIcon className={styles.refreshContactListIcon} onClick={() => getThreadTagApiCall()} />
                                </GlobalTooltip>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default AssignAndRemoveTagComponent
